<template>
  <div>
    <div
      @click="handleOpenDatePicker"
      style="border-bottom: 1px solid #c7c7c7; padding: 5px 15px;"
    >
      <i class="el-icon-date" style="margin-right: 15px;"></i>
      <span v-bind:class="classObject">{{ dateStr }}</span>
    </div>
    <van-popup
      v-if="!readonly"
      v-model="show"
      round
      get-container="body"
      position="bottom"
      safe-area-inset-bottom
    >
      <van-datetime-picker
        v-model="date"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="handleChangeDate"
        @cancel="handleCancelDate"
        get-container="body"
      />
    </van-popup>
  </div>
</template>
<script>
import { DatetimePicker, Popup } from "vant";
import { Icon } from "element-ui";
import moment from "moment";

export default {
  name: "date-picker",
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String,
    placeholder: {
      type: String,
      default: "请选择日期",
    },
    format: {
      type: String,
      default: "YYYY 年 MM 月 DD 日",
    },
    valueFormat: {
      type: String,
      default: "YYYY-MM-DD",
    },
    readonly: Boolean,
  },
  data() {
    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 100);
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() + 100);
    return {
      show: false,
      date: null,
      minDate,
      maxDate,
    };
  },
  computed: {
    dateStr() {
      const { value, format, placeholder } = this.$props;
      if (value) {
        return moment(value).format(format);
      }
      return placeholder;
    },
    classObject() {
      return { "clr-grey": !this.$props.value };
    },
  },
  methods: {
    handleOpenDatePicker() {
      if (this.$props.readonly) {
        return;
      }
      this.show = true;
      if (this.$props.value) {
        this.date = new Date(this.$props.value);
      } else {
        this.date = new Date();
      }
    },
    handleChangeDate(value) {
      const str = moment(value).format(this.$props.valueFormat);
      this.$emit("change", str);
      this.handleCancelDate();
    },
    handleCancelDate() {
      this.show = false;
    },
  },
};
</script>
<style scoped>
.clr-grey {
  color: grey;
}
</style>
